import "./TheWeekendAgenda.module.css";
import Header from "@/reusable_sections/Header";
import TheMainEventMore from "./sections/TheMainEventMore";
import WhereToMeet from "./sections/WhereToMeet";
import Footer from "@/reusable_sections/Footer";
export default function TheWeekendAgendaPage() {
  return <div>
      <Header />
      <TheMainEventMore />
      <WhereToMeet />
      <Footer />
    </div>;
}